import { render } from "./UnusableChoices.vue?vue&type=template&id=1d3c0a68&scoped=true"
import script from "./UnusableChoices.vue?vue&type=script&lang=js"
export * from "./UnusableChoices.vue?vue&type=script&lang=js"

import "./UnusableChoices.vue?vue&type=style&index=0&id=1d3c0a68&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d3c0a68"]])

export default __exports__